module.exports = __webpack_public_path__ + "img/Immigration.30ebb9a0.svg";